import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-near-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-serif font-bold mb-4">Ravi Prakash</h3>
            <p className="text-gray-400 text-sm font-sans">
              Keynote Speaker, Author, Leadership Expert
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-sans font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-safar-orange transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/speaking" className="text-gray-400 hover:text-safar-orange transition-colors text-sm">
                  Speaking
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-gray-400 hover:text-safar-orange transition-colors text-sm">
                  Book
                </Link>
              </li>
              <li>
                <Link to="/media-kit" className="text-gray-400 hover:text-safar-orange transition-colors text-sm">
                  Media Kit
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-sans font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Keynote Speaking</li>
              <li>Fireside Chats</li>
              <li>Panel Discussions</li>
              <li>Book Signing Events</li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-lg font-sans font-semibold mb-4">Connect</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/book-ravi"
                  className="flex items-center text-gray-400 hover:text-safar-orange transition-colors text-sm"
                >
                  <Mail className="h-4 w-4 mr-2" />
                  Contact Ravi
                </Link>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/journeywithravi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-400 hover:text-safar-orange transition-colors text-sm font-semibold"
                >
                  <Linkedin className="h-4 w-4 mr-2" />
                  Follow on LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/newsletters/journey-with-ravi-7327477739354009600"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-safar-orange hover:text-burnt-orange transition-colors text-sm font-semibold"
                >
                  <Linkedin className="h-4 w-4 mr-2" />
                  Leadership Journeys With Ravi (1,500+ readers)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm font-sans">
            © {new Date().getFullYear()} Ravi Prakash. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2 font-sans">
            Available for keynotes, fireside chats, panels, graduations, and book signing events • In-person and virtual
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
